module.exports = "<p>\n  user-info-dialog works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/user-info-dialog/user-info-dialog.component.html
// module id = ../../../../../src/app/component/user-info-dialog/user-info-dialog.component.html
// module chunks = 1